import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { DriversContent } from "@/features/dashboard/motoristas/components/DriversContent";

export const Route = createFileRoute("/_private/dashboard/_base/motoristas/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Editar Motorista" from="/dashboard/motoristas/editar/$id">
      <DriversContent />
    </BaseEditCreateModal>
  );
}
